import { HeaderActionArea, IconButton } from '@deere/fuel-react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { useNavigate } from 'react-router-dom';

export const SupportRequestHeaderAction = () => {
    const navigate = useNavigate();

    return (
        <HeaderActionArea>
            <IconButton
                aria-label="Support request"
                onClick={() => navigate('/support-request')}
            >
                <ReportProblemOutlinedIcon />
            </IconButton>
        </HeaderActionArea>
    );
};
